var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.04883 21V11C4.49883 11 4.02799 10.8042 3.63633 10.4125C3.24466 10.0208 3.04883 9.55 3.04883 9V3.7C3.04883 3.5 3.11549 3.33333 3.24883 3.2C3.38216 3.06667 3.54883 3 3.74883 3C3.94883 3 4.11549 3.06667 4.24883 3.2C4.38216 3.33333 4.44883 3.5 4.44883 3.7V7H5.34883V3.7C5.34883 3.5 5.41549 3.33333 5.54883 3.2C5.68216 3.06667 5.84883 3 6.04883 3C6.24883 3 6.41549 3.06667 6.54883 3.2C6.68216 3.33333 6.74883 3.5 6.74883 3.7V7H7.64883V3.7C7.64883 3.5 7.71549 3.33333 7.84883 3.2C7.98216 3.06667 8.14883 3 8.34883 3C8.54883 3 8.7155 3.06667 8.84883 3.2C8.98216 3.33333 9.04883 3.5 9.04883 3.7V9C9.04883 9.55 8.85299 10.0208 8.46133 10.4125C8.06966 10.8042 7.59883 11 7.04883 11V21H5.04883ZM12.0488 21V10.9C11.3488 10.5667 10.8405 10.0458 10.5238 9.3375C10.2072 8.62917 10.0488 7.88333 10.0488 7.1C10.0488 6.05 10.3113 5.10417 10.8363 4.2625C11.3613 3.42083 12.0988 3 13.0488 3C13.9988 3 14.7363 3.42083 15.2613 4.2625C15.7863 5.10417 16.0488 6.05 16.0488 7.1C16.0488 7.88333 15.8905 8.62917 15.5738 9.3375C15.2572 10.0458 14.7488 10.5667 14.0488 10.9V21H12.0488ZM17.0488 21V3C18.1488 3 19.0905 3.39167 19.8738 4.175C20.6572 4.95833 21.0488 5.9 21.0488 7V13H19.0488V21H17.0488Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeal);
export default __webpack_public_path__ + "static/media/meal.44e87ad79d4156c47ebc41dc3434c008.svg";
export { ForwardRef as ReactComponent };